import { css, cx } from '@emotion/css';
import { Flex, Popover, Tag, theme } from 'antd';
import type React from 'react';
import type { ReactNode } from 'react';

export const TableList: React.FC<{
  entries: ReactNode[];
  maxEntries?: number;
  withinModal?: boolean;
  raw?: boolean;
  /** Render the entries in monospace — use when the entries are codes/identifiers (e.g. Kurznamen). */
  mono?: boolean;
}> = ({ entries, maxEntries = 5, withinModal, raw, mono }) => {
  const { token } = theme.useToken();

  const monoClass = mono
    ? css`
        font-family: ${token.fontFamilyCode};
      `
    : undefined;

  const mainEntries = entries.slice(0, maxEntries);
  const restEntries = entries.slice(maxEntries, entries.length);

  return (
    <Flex gap="small">
      {mainEntries.map((entry, index) =>
        raw ? (
          <span key={index} className={monoClass}>
            {entry}
          </span>
        ) : (
          <Tag key={index} className={monoClass}>
            {entry}
          </Tag>
        )
      )}
      {!!restEntries.length && (
        <Popover
          zIndex={withinModal ? 9999 : 900 /* behind modal */}
          classNames={{
            root: css`
              max-width: 500px;
              .ant-popover-container {
                padding: 0;
              }
            `,
          }}
          content={
            <div
              className={css`
                padding: ${token.paddingSM}px;
                padding-bottom: calc(${token.paddingSM}px - ${token.paddingXS}px);
              `}
              onClick={e => e.stopPropagation()}
            >
              {restEntries.map((entry, index) =>
                raw ? (
                  <span
                    key={index}
                    className={cx(
                      css`margin-bottom: ${token.paddingXS}px; margin-right: ${token.paddingXS}px; display: inline-block;`,
                      monoClass
                    )}
                  >
                    {entry}
                  </span>
                ) : (
                  <Tag key={index} className={cx(css`margin-bottom: ${token.paddingXS}px; margin-right: ${token.paddingXS}px;`, monoClass)}>
                    {entry}
                  </Tag>
                )
              )}
            </div>
          }
          trigger="click"
        >
          <Tag
            className={css`
              color: ${token.colorLink};
              cursor: pointer;
            `}
            onClick={e => {
              document.body.click();
              e.stopPropagation();
            }}
          >
            +{restEntries.length}
          </Tag>
        </Popover>
      )}
    </Flex>
  );
};
